import { UseI18n } from '~/app/i18n/i18n';
import { Incentive } from '~/graphql/__generated__/graphql';

//! This function MUST be used to display the incentives. If an incentive is selected, the incentives order from backend changes, so we have to handle that ourself.
export const sortIncentives = (arr: Incentive[]) => {
	// Separate strings starting with numbers and those that do not
	const numericStrings: Incentive[] = [];
	const nonNumericStrings: Incentive[] = [];

	arr.forEach((incentive) => {
		if (incentive.action.title) {
			if (/^\d/.test(incentive.action.title)) {
				numericStrings.push(incentive);
			} else {
				nonNumericStrings.push(incentive);
			}
		}
	});

	// Sort non-numeric strings alphabetically
	nonNumericStrings.sort((a, b) => a.action.title!.localeCompare(b.action.title!));

	// Sort numeric strings alphabetically
	numericStrings.sort((a, b) => a.action.title!.localeCompare(b.action.title!));

	// Concatenate the sorted non-numeric strings with the sorted numeric strings
	return nonNumericStrings.concat(numericStrings);
};

export const getSubtitle = (
	i18n: UseI18n,
	description: string,
	date: string | null,
	market: string,
	language: string,
) => {
	const prefix = description ? `${description}. ` : '';
	const validTo = date
		? i18n('ngc.incentives.validUntil', {
				date: formatDate(date, market, language),
			})
		: '';
	return `${prefix}${validTo}`;
};

export const formatDate = (input: string | null, market: string, language: string) => {
	if (!input) return;
	return Intl.DateTimeFormat(`${market.toUpperCase()}-${language}`, {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).format(new Date(input));
};
